function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M234.572 42.8936H21.572C10.267 42.8936 1.07202 52.0896 1.07202 63.3936V186.395C1.07202 197.699 10.267 206.895 21.572 206.895H234.572C245.875 206.895 255.072 197.699 255.072 186.395V63.3936C255.072 52.0896 245.875 42.8936 234.572 42.8936ZM21.572 53.8936H234.572C239.81 53.8936 244.072 58.1556 244.072 63.3936V75.6516H12.072V63.3936C12.072 58.1546 16.333 53.8936 21.572 53.8936ZM234.572 195.895H21.572C16.334 195.895 12.072 191.633 12.072 186.395V86.6516H244.072V186.395C244.072 191.633 239.81 195.895 234.572 195.895Z",
  fill: "black"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M72.119 158.228H35.24C32.203 158.228 29.74 160.69 29.74 163.728C29.74 166.766 32.203 169.228 35.24 169.228H72.119C75.156 169.228 77.619 166.766 77.619 163.728C77.619 160.69 75.156 158.228 72.119 158.228Z",
  fill: "black"
});

function SvgIconWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 257 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.0e216851bf548222aab1fce3f0b85448.svg";
export { ForwardRef as ReactComponent };